import { useTranslation } from "react-i18next";
import { AppInput } from "../../../../../../../shared/components/AppInput";
import { AppCheckbox } from "../../../../../../../shared/components/AppCheckbox";
import { TSpeakerContent } from "../../../../../../../services/api/instances/meetingsApi/types";
import {
  CUSTOM_SPEAKER_NAME,
  SPEAKER_UNDEFINED,
} from "../../../../../constants";
import { ChangeHandlerValue, TSpeakerActions } from "../../../../../types";
import styles from "./styles.module.css";
import { DeleteButton } from "../../../../../../../common/Components/Buttons/DeleteButton";

interface Props {
  serialNumber: number;
  speaker: Omit<TSpeakerContent, "speech_content">;
  handleSpeakerActions: (
    id: string,
    value: ChangeHandlerValue,
    type: TSpeakerActions
  ) => void;
  handleSpeakerDelete: (
    speaker: Omit<TSpeakerContent, "speech_content">
  ) => void;
  className?: string;
}

export const SpeakerItem = ({
  serialNumber,
  speaker,
  handleSpeakerActions,
  handleSpeakerDelete,
  className,
}: Props) => {
  const { t } = useTranslation();

  if (speaker.speaker_group_key === SPEAKER_UNDEFINED) return;

  return (
    <div className={`${styles["item-container"]} ${className}`}>
      <div
        className={styles["speaker-label"]}
      >{`${t("meetings.custom_speaker")}_${serialNumber}:`}</div>
      <AppInput
        value={speaker.speaker_name}
        onChange={(e) =>
          handleSpeakerActions(
            speaker.speaker_group_key,
            e.target.value,
            "name_change"
          )
        }
        className={styles["change-name-input"]}
      />
      <AppCheckbox
        checked={speaker.isActive}
        onChange={(e) =>
          handleSpeakerActions(
            speaker.speaker_group_key,
            e.target.checked,
            "active_change"
          )
        }
      />
      {speaker.speaker_group_key.startsWith(CUSTOM_SPEAKER_NAME) && (
        <DeleteButton
          entityId={speaker.speaker_group_key}
          onDelete={() => handleSpeakerDelete(speaker)}
        />
      )}
    </div>
  );
};
